import { appLocalStorage } from '../utils/storage';

const closed = new Set();
export const localDeletionKey = id => `account-deletion:local:${id}`;
const validOwner = id => Number.isSafeInteger(Number(id)) && Number(id) > 0;

// A local fence is installed only after explicit server proof/accepted deletion.
// Ordinary expiry, logout, offline and 401 must never create this tombstone.
export function isDeletedOwner(id) {
  if (!validOwner(id)) return false;
  const owner = Number(id);
  if (closed.has(owner)) return true;
  try {
    if (appLocalStorage.getItem(localDeletionKey(owner))) { closed.add(owner); return true; }
  } catch { /* Retain this document's proof when browser storage is unavailable. */ }
  return false;
}

export function markDeletedOwner(id) {
  if (!validOwner(id)) throw new Error('INVALID_DELETED_OWNER');
  const owner = Number(id);
  closed.add(owner);
  let durable = true;
  try { appLocalStorage.setItem(localDeletionKey(owner), 'pending'); } catch { durable = false; }
  window.dispatchEvent(new CustomEvent('wiw:account-deleted', { detail: { userId: owner } }));
  return durable;
}

export function assertDraftOwnerActive(id) {
  if (isDeletedOwner(id)) throw new Error('ACCOUNT_DELETED');
}
